module.exports = __webpack_public_path__ + "img/5.4c458b91.jpg";